<template>
  <!--    通用表格组件-->
  <!--    1.接收Columns<Array>数组-->
  <!--    列名：LabelName<String>,是否固定列：fixed<Boolean>列宽：row<Number>,是否居中：align<String>(可选left，right，center),
序号：key<Number>,字段名：ColumnsKey<String>,搜索栏字段：seek<String>,是否添加标签：Tag<Boolean>,
  搜索栏提示文字：placeholder<String>,额外的处理函数：Fun<String>-->
  <!--    2.接收Coluumns<Array>Button数组-->
  <!--    序号：key<String>,按钮类型：type<String>,按钮图标：icon<String>,按钮操作函数：Fun<String>,
  是否禁用函数：disabled:<String>,通过哪个字段判断是否禁用ColumnsKey:<String>,是否为删除按钮：Delete<Boolean>-->
  <!--    3.ColuumnsButtonWidth<Number>操作列宽度-->
  <!--    4.RowKey<String>表格row-key-->
  <!--    5.data<Array>表格数据数组-->
  <!--    seek<Object>搜索栏对应的每个搜索字段-->
  <!--    6.DeleteTitle<String>时间提示框标题-->
  <!-- sort <boolean> 是否支持排序-->
  <!-- isChexkBox 是否需要复选按钮, false则不显示，其他默认显示 -->
  <!-- isRadio是否需要单选按钮, isRadio == true和isChexkBox === false才显示 -->
  <!-- radioLabel绑定的值 -->
  <!-- Height 自定义表格高度，默认是650-->
  <!-- select: true为选择下拉框，fasle为输入框，selectOptions是下拉框选项 -->
  <!-- tipValue定义按钮提示文字，不填则默认不显示 -->
  <div>
    <!--    表格组件-->
    <el-table
      :data="data"
      :height="Height ? Height : 650"
      border
      size="mini"
      id="out-table"
      :row-key="getRowkey"
      :header-cell-style="{ background: '#e4f1ff' }"
      @selection-change="handleSelectionChange"
      @sort-change="sortChange"
      style="overflow-y:scroll"
      :lazy="lazy"
      :load="load"
      ref="TableComponents"
      :tree-props="TreeProps"
      :expand-row-keys="expandArr"
      @expand-change="expandChange"
    >
      <el-table-column
        align="center"
        v-if="isChexkBox !== false"
        type="selection"
        width="50"
        reserve-selection
        :selectable="checkboxInit"
      ></el-table-column>
      <el-table-column
        align="center"
        v-else-if="isChexkBox === false && isRadio === true"
        width="50"
      >
        <template slot-scope="scope">
          <el-radio v-if="scope.$index === 0" disabled>{{ '' }}</el-radio>
          <el-radio
            v-else
            v-model="radioValue"
            :label="scope.row[radioLabel]"
            @change="handleSelectionChange(scope.row)"
          >{{ '' }}</el-radio>
        </template>
      </el-table-column>
      <!--      子表格-->
      <el-table-column type="expand" align="center" v-if="Expand">
        <template slot-scope="scope">
          <div v-if="scope.row[ExpandKey]">
            <el-table size="mini" style="width: 100%;" :data="scope.row[ExpandKey]">
              <el-table-column
                :label="Item.LabelName"
                :align="Item.align"
                v-for="(Item) in Expands"
                :width="Item.row"
                :key="Item.key"
                :fixed="Item.fixed"
              >
                <template slot-scope="scope">
                  <!--          表格状态标签-->
                  <el-tag
                    v-if="!Item.slot && Item.Tag"
                    :type="$parent[Item.Fun](scope.row[Item.ExpandsKey]).status"
                  >{{ $parent[Item.Fun](scope.row[Item.ExpandsKey]).TagName }}</el-tag>
                  <!--            自定义插槽-->
                  <slot v-if="Item.slot" name="ChildSlot" :scope="scope"></slot>
                  <!-- 自定义单元格内容的显示 -->
                  <slot v-if="Item.isChildCustom === true" :scope="scope" name="childCustomColumn"></slot>
                  <!--                        内容-->
                  <span
                    class="Table_Tetx"
                    v-if="!Item.slot && !Item.Tag && Item.isChildCustom !== true"
                    :title="Item.Fun ? $parent[Item.Fun](scope.row) : scope.row[Item.ExpandsKey]"
                  >{{ Item.Fun ? $parent[Item.Fun](scope.row) : scope.row[Item.ExpandsKey] }}</span>
                </template>
              </el-table-column>
              <el-table-column :label="$t('lang.TableComponent.operating')" align="center">
                <template slot-scope="scope">
                  <!--          子表格操作按钮-->
                  <span v-for="Item in ExpandsButton" :key="Item.key" style="margin-left: 10px">
                    <el-button
                      :type="Item.type"
                      :icon="Item.icon"
                      v-if="Authority.indexOf(Item.Authority) != -1"
                      :disabled="Item.disabled ? $parent[Item.disabled](scope.row[Item.ExpandsKey]) : Item.disabled"
                      @click="Item.Delete ? opendelete(Item.Fun, scope.row) : $emit(Item.Fun, scope.row)"
                      circle
                    />
                  </span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </template>
      </el-table-column>
      <!--      表格列-->
      <el-table-column
        :label="Item.LabelName"
        :align="Item.align"
        v-for="(Item) in Columns"
        :width="Item.row"
        :key="Item.key"
        :fixed="Item.fixed"
        :prop="Item.ColumnsKey"
        :sortable="Item.sort ? Item.sort : false"
      >
        <template slot-scope="scope">
          <!--            表格首栏搜索框-->
          <el-select
            size="mini"
            v-model="seek[Item.seek]"
            v-if="scope.$index == 0 && Item.seek && Item.select"
            clearable
          >
            <el-option
              v-for="ele in  Item.selectOptions"
              :key="ele.value"
              :label="ele.label"
              :value="ele.value"
            ></el-option>
          </el-select>
          <el-input
            v-if="scope.$index == 0 && Item.seek && !Item.select"
            size="mini"
            clearable
            :placeholder="Item.placeholder"
            v-model.trim="seek[Item.seek]"
          ></el-input>
          <!-- <el-input
            v-if="scope.$index==0&&Item.seek"
            size="mini"
            clearable
            :placeholder="Item.placeholder"
            v-model="seek[Item.seek]">
          </el-input>-->
          <!--          表格状态标签-->
          <el-tag
            v-if="!Item.slot && Item.Tag && scope.$index !== 0"
            :type="$parent[Item.Fun](scope.row[Item.ColumnsKey]).status"
          >{{ $parent[Item.Fun](scope.row[Item.ColumnsKey]).TagName }}</el-tag>
          <!--            自定义插槽-->
          <slot v-if="Item.slot && scope.$index !== 0" name="slot" :scope="scope"></slot>
          <slot v-if="Item.slot && scope.$index !== 0" name="otherSlot" :scope="scope"></slot>
          <slot v-if="Item.name && scope.$index !== 0" name="nameSlot" :scope="scope"></slot>
          <!-- <slot v-if="scope.$index !== 0 && Item.deviceInfo3g4g" name="deviceInfo3g4gSlot" :scope="scope"></slot> -->
          <!-- 自定义单元格内容的显示 -->
          <slot
            v-if="Item.isCustom === true && scope.$index !== 0 && !Item.convert"
            :scope="scope"
            name="customColumn"
          ></slot>
          <slot
            v-if="Item.isCustom === true && scope.$index !== 0&& Item.convert "
            :scope="scope"
            name="convert"
          >
          <span v-if="Item.keyName=='WANPortTraffic'">{{ scope.row.deviceTraffic1|flowFormat }}</span>
          <span v-if="Item.keyName=='_3GWAN1Traffic'">{{ scope.row.deviceTraffic2|flowFormat }}</span>
          <span v-if="Item.keyName=='_3GWAN2Traffic'">{{ scope.row.deviceTraffic3|flowFormat }}</span>
        </slot>
          <slot v-if="scope.$index !== 0 && Item.type" name="typeslot" :scope="scope"></slot>
          <!--            内容-->
          <span
            class="Table_Tetx"
            v-if="!Item.type && !Item.slot && !Item.Tag && scope.$index !== 0 && Item.isCustom !== true&&Item.name !== true"
            :title="Item.Fun ? $parent[Item.Fun](scope.row) : scope.row[Item.ColumnsKey]"
          >{{ Item.Fun ? $parent[Item.Fun](scope.row) : scope.row[Item.ColumnsKey] }}</span>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('lang.TableComponent.operating')"
        align="center"
        v-if="ColuumnsButton.length > 0"
        :width="ColuumnsButtonWidth"
        :fixed="btnFixed?'right':false"
      >
        <template slot-scope="scope">
          <!--表格操作按钮-->
          <span v-for="Item in ColuumnsButton" :key="Item.key" >
            <slot v-if="scope.$index !== 0 && Item.buttonSlot" name="buttonSlot"></slot>
            <el-tooltip effect="light" :content="Item.tipValue" :disabled="!Item.tipValue">
              <el-button
                :type="Item.icon2?scope.row[Item.icon2ActiveKey]==Item.icon2ActiveValue?Item.type:Item.type2:Item.type"
                :icon="Item.icon2?scope.row[Item.icon2ActiveKey]==Item.icon2ActiveValue?Item.icon:Item.icon2:Item.icon"
                :disabled="Item.disabled ? $parent[Item.disabled](scope.row[Item.ColumnsKey],scope.row[Item.ColumnsKey2]) : Item.disabled"
                v-if="scope.$index !== 0 && Authority.indexOf(Item.Authority) != -1"
                @click="Item.Delete ? opendelete(Item.Fun, scope.row) : $emit(Item.Fun, scope.row)"
                circle
              />
            </el-tooltip>
          </span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import { getPermission } from "@/cookie/cookie";
import { getuser_iscustomer, getuser_ctid } from "@/localStorage/localStorage";
import { getGroupList } from "../../api/groupinglist";
import { GetListConfig } from "../../api/task";
export default {
  props: {
    data: {
      type: Array,
      default: () => []
    },
    Columns: {
      type: Array,
      default: () => []
    },
    ColuumnsButton: {
      type: Array,
      default: () => []
    },
    btnFixed:{
      type:Boolean,
      default:false
    },
    RowKey: {
      type: String
    },
    btnFixed:{
      type:Boolean,
      default:false
    },
    ColuumnsButtonWidth: {
      type: Number
    },
    seek: {
      type: Object
    },
    DeleteTitle: {
      type: String,
      default: () => "提示"
    },
    Tree: {
      type: Object,
      default: () => { }
    },
    Expand: {
      type: Boolean,
      default: () => false
    },
    ExpandKey: {
      type: String
    },
    Expands: {
      type: Array,
      default: () => []
    },
    ExpandsButton: {
      type: Array,
      default: () => []
    },
    lazy: {
      type: Boolean,
      default: () => false
    },
    TreeProps: {
      type: Object,
      default: () => { }
    },
    //展开行ID
    ExpandId: {
      type: String
    },
    isChexkBox: {
      type: Boolean,
      default: true
    },
    Height: {
      type: String,
      default: ''
    },
    isRadio: {
      type: Boolean,
      default: false
    },
    radioLabel: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      Authority: getPermission(),
      expandArr: [],
      map: new Map(), //手动刷新表格
      radioValue: '',
      Admin:
        getuser_iscustomer() == 2 ||
          (getuser_ctid() == 0 && getuser_iscustomer() == 1)
          ? true
          : false
    };
  },
  methods: {
    //删除按钮最终确认确认事件
    opendelete(Fun, row) {
      this.$confirm(this.$t("lang.DeleteBox.Tetx"), this.DeleteTitle=="提示"?this.$t("lang.editVar.msg22"):this.DeleteTitle, {
        confirmButtonText: this.$t("lang.DeleteBox.confirmButtonText"),
        cancelButtonText: this.$t("lang.DeleteBox.cancelButtonText"),
        type: "warning",
        center: true
      })
        .then(() => {
          this.$emit(Fun, row);
        })
        .catch(() => { });
    },
    //表格选择框
    handleSelectionChange(val) {
      this.$emit("handleSelectionChange", val);
    },
    //表格排序
    sortChange({ column, prop, order }) {
      this.$emit("sortChange", column, prop);
    },
    //禁止第一行搜索栏选中
    checkboxInit(row, index) {
      if (index == 0) {
        return 0;
      } else {
        return 1;
      }
    },
    //懒加载
    load(tree, treeNode, resolve) {
      console.log('loading');
      console.log(tree.group_id);
      this.map.set(tree.group_id, { tree, treeNode, resolve })
      getGroupList(1, 1000, tree.group_id).then(res => {
        resolve(res.data.data.list);
      });
    },
    // 刷新表格数据
    reFleshTable(goupId) { // 在哪个分组下添加
      const { tree, treeNode, resolve } = this.map.get(goupId)
      this.load(tree, treeNode, resolve);
    },
    //获取子任务列表
    expandChange(row, expandedRows) {
      if (row.tId) {
        if (expandedRows.length > 0) {
          this.expandArr = []
          if (row) {
            this.$emit("GetSubtasks", row.tId);
            this.expandArr.push(row.tId)
          }
        } else {
          this.expandArr = []
        }
      } else {
        this.expandArr = []
      }
    },
    getRowkey(row) {
      return row[this.RowKey]
    },
    // 清除选中状态
    cancelSelect() {
      this.$refs.TableComponents.clearSelection()
    }
  },
  watch: {
    seek: {
      handler(NewValue, OldValue) {
        this.$emit("GetSeek", NewValue);
      }
    }
  },
  filters:{
    // 流量格式化，把kb转换成mb，若超过1024mb，则转换成gb
    flowFormat(value) {
      if (value < 1024) {
        return value + 'KB'
      } else if (value >= 1024 && value < 1024 * 1024) {
        return (value / 1024).toFixed(2) + 'MB'
      } else if (value >= 1024 * 1024) {
        return (value / 1024 / 1024).toFixed(2) + 'GB'
      }
    }
  }
};
</script>
<style scoped>
.Table_Tetx {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 0.25rem;
  height: 41px;
}
.el-table__expand-icon {
  display: inline-block !important;
}
</style>
